/**
 * Inline CSS for the player UI. Injected once into <head>.
 *
 * Build D will move this into the SPA's zap.css (under .zap-player-* namespace).
 * For now we keep it self-contained so the IIFE bundle is drop-in.
 */

const CSS = `
  .zap-pe-strip { position: relative; height: 56px; background: rgba(0,0,0,.6);
                  border-top: 1px solid rgba(255,255,255,.08); user-select: none;
                  touch-action: none; margin-top: 4px; }
  .zap-pe-track { position: absolute; left: 0; top: 50%; right: 0; height: 4px;
                  transform: translateY(-50%); background: rgba(255,255,255,.08); border-radius: 2px; }
  .zap-pe-cursor { position: absolute; top: 0; bottom: 0; width: 2px;
                   background: #1ED760; pointer-events: none; transform: translateX(-1px); z-index: 4;
                   box-shadow: 0 0 4px rgba(30,215,96,.7); }
  .zap-pe-regions { position: absolute; inset: 0; pointer-events: none; }
  .zap-pe-ticks   { position: absolute; left: 0; right: 0; bottom: 4px; height: 8px; pointer-events: none; }
  .zap-pe-tick    { position: absolute; bottom: 0; width: 1px; background: rgba(255,255,255,.4); }
  .zap-pe-tick--major { height: 8px; background: rgba(255,255,255,.7); }
  .zap-pe-tick--minor { height: 4px; }
  .zap-pe-tick-label { position: absolute; bottom: 8px; transform: translateX(-50%);
                        font-family: monospace; font-size: 9px; color: rgba(255,255,255,.6); }
  .zap-pe-region { position: absolute; top: 6px; bottom: 14px; border-radius: 4px;
                   display: flex; align-items: center; padding: 0 6px; gap: 4px;
                   font-size: 11px; color: #fff; pointer-events: auto; cursor: pointer;
                   min-width: 28px; overflow: hidden; }
  .zap-pe-region--skip          { background: rgba(220,60,60,.55);   border: 1px solid rgba(220,60,60,.85); }
  .zap-pe-region--include       { background: rgba(70,120,160,.55);  border: 1px solid rgba(70,120,160,.85); }
  .zap-pe-region--repeat        { background: rgba(220,140,40,.55);  border: 1px solid rgba(220,140,40,.85); }
  .zap-pe-region--reverse       { background: rgba(160,80,200,.55);  border: 1px solid rgba(160,80,200,.85); }
  .zap-pe-region--fwd-back-fwd  { background: rgba(220,80,160,.55);  border: 1px solid rgba(220,80,160,.85); }
  .zap-pe-region--off           { background: rgba(120,120,120,.45); opacity: .55; border: 1px solid rgba(120,120,120,.7); }
  .zap-pe-region:hover          { filter: brightness(1.18); }
  .zap-pe-region.is-active      { box-shadow: 0 0 0 2px #fff inset; }
  .zap-pe-handle { position: absolute; top: -3px; bottom: -3px; width: 12px;
                   cursor: ew-resize; background: rgba(255,255,255,.55); border-radius: 2px;
                   transition: background .12s; z-index: 3; }
  .zap-pe-handle--start { left: -6px; }
  .zap-pe-handle--end   { right: -6px; }
  .zap-pe-handle:hover  { background: #fff; }
  .zap-pe-region-label  { flex: 1; min-width: 0; white-space: nowrap; overflow: hidden;
                          text-overflow: ellipsis; pointer-events: none; }
  .zap-pe-mode-icon     { font-size: 11px; opacity: .85; pointer-events: none; }
  .zap-pe-region-toggle, .zap-pe-region-del {
    background: rgba(0,0,0,.45); border: 0; color: #fff;
    width: 16px; height: 16px; border-radius: 50%; font-size: 10px;
    cursor: pointer; display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
  }
  .zap-pe-region-toggle:hover, .zap-pe-region-del:hover { background: rgba(0,0,0,.78); }
  .zap-pe-banner { position: absolute; top: 12px; left: 50%; transform: translateX(-50%);
                   background: rgba(20,22,28,.92); padding: 8px 14px; border-radius: 6px;
                   font-size: 13px; color: #fff; z-index: 5; box-shadow: 0 6px 20px rgba(0,0,0,.5);
                   border: 1px solid rgba(255,255,255,.14); display: inline-flex;
                   align-items: center; gap: 8px; white-space: nowrap; pointer-events: auto; }
  .zap-pe-banner.is-active { border-color: #1ED760; box-shadow: 0 6px 20px rgba(30,215,96,.35); }
  .zap-pe-banner strong { color: #1ED760; font-family: monospace; }
  .zap-pe-banner kbd { display: inline-block; padding: 1px 5px; background: rgba(255,255,255,.14);
                        border: 1px solid rgba(255,255,255,.22); border-radius: 3px;
                        font-family: monospace; font-size: 11px; }
  .zap-pe-banner button { background: rgba(255,255,255,.16); border: 1px solid rgba(255,255,255,.24);
                          color: #fff; padding: 3px 8px; border-radius: 4px; font-size: 11px;
                          cursor: pointer; font-family: inherit; }
  .zap-pe-banner button:hover { background: rgba(255,255,255,.28); }
  .zap-skipbtn { position: absolute; right: 20px; bottom: 84px; z-index: 8;
                 background: rgba(255,255,255,.94); color: #111;
                 border: 0; border-radius: 6px; padding: 11px 20px;
                 font-size: 14px; font-weight: 600; font-family: inherit;
                 cursor: pointer; pointer-events: auto;
                 box-shadow: 0 4px 16px rgba(0,0,0,.45); }
  .zap-skipbtn:hover { background: #fff; transform: scale(1.03); }
  .zap-skipbtn[hidden] { display: none; }
  .zap-pe-hovertip { position: absolute; bottom: 100%; transform: translateX(-50%);
                      background: rgba(0,0,0,.85); color: #fff; padding: 3px 7px;
                      border-radius: 3px; font-family: monospace; font-size: 11px;
                      pointer-events: none; white-space: nowrap; margin-bottom: 4px; z-index: 6; }
  .zap-pe-popover { position: absolute; background: rgba(20,22,28,.95);
                    border: 1px solid rgba(255,255,255,.18); border-radius: 8px;
                    padding: 12px; color: #fff; font-size: 13px; z-index: 10;
                    box-shadow: 0 8px 24px rgba(0,0,0,.6); min-width: 260px; }
  .zap-pe-popover label { display: flex; flex-direction: column; gap: 4px; margin-bottom: 8px; font-size: 11px; color: rgba(255,255,255,.75); }
  .zap-pe-popover input, .zap-pe-popover select {
    background: rgba(255,255,255,.08); color: #fff; border: 1px solid rgba(255,255,255,.18);
    border-radius: 3px; padding: 4px 6px; font-size: 13px; font-family: inherit;
  }
  .zap-pe-popover select option { background: #1a1f28; }
  .zap-pe-popover .row { display: flex; gap: 8px; align-items: center; justify-content: flex-end; margin-top: 8px; }
  .zap-pe-popover button { background: rgba(255,255,255,.16); border: 1px solid rgba(255,255,255,.24);
                            color: #fff; padding: 4px 10px; border-radius: 4px; cursor: pointer;
                            font-family: inherit; font-size: 12px; }
  .zap-pe-popover button.primary { background: #1ED760; border-color: #1ED760; }
  .zap-pe-popover button:hover { filter: brightness(1.15); }

  /* Resume banner (centered, prompt) */
  .zap-pe-resume { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
                    z-index: 6; background: rgba(20,22,28,.95);
                    border: 1px solid rgba(255,255,255,.18); border-radius: 8px;
                    padding: 14px 18px; display: flex; align-items: center; gap: 10px;
                    color: #fff; font-size: 14px; box-shadow: 0 10px 32px rgba(0,0,0,.6); }
  .zap-pe-resume strong { font-family: monospace; color: #1ED760; }
  .zap-pe-resume button { background: rgba(255,255,255,.16); border: 1px solid rgba(255,255,255,.24);
                           color: #fff; padding: 6px 12px; border-radius: 4px; cursor: pointer;
                           font-family: inherit; font-size: 13px; }
  .zap-pe-resume button.primary { background: #1ED760; border-color: #1ED760; }
  .zap-pe-resume button:hover { filter: brightness(1.15); }

  /* Fullscreen editor layout */
  .zap-pe-fullscreen {
    background: #000;
    display: flex; flex-direction: column;
    width: 100vw; height: 100vh; padding: 0; margin: 0;
  }
  .zap-pe-fullscreen video {
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    /* Defeat .player-overlay__video { max-height: 70vh } from the modal-mode
       sibling rule. Without this the video maxes out at 70vh in fullscreen
       and a black flex-gap of 30vh appears below it. */
    max-height: none;
    min-height: 0;
    object-fit: contain;
    background: #000;
    cursor: pointer;
    margin: 0 !important;
  }
  .zap-pe-fullscreen .zap-pe-strip {
    flex: 0 0 72px;
    height: 72px;
    margin: 0 !important;
  }
  .zap-pe-fullscreen .zap-pe-region { font-size: 12px; }
  .zap-pe-fullscreen .zap-pe-handle { width: 14px; }
  .zap-pe-fullscreen .player-hint,
  .zap-pe-fullscreen .player-meta,
  .zap-pe-fullscreen .player-actions,
  .zap-pe-fullscreen .player-url-field,
  .zap-pe-fullscreen .btn { display: none !important; }
  .zap-pe-fullscreen video::-webkit-media-controls,
  .zap-pe-fullscreen video::-webkit-media-controls-enclosure { display: none !important; }

  /* === Modal shell (.player-overlay*) ===========================================
     The SPA (Files-Tab) has these rules in zap.css, but Filmdir loads ONLY this
     IIFE bundle — without these, the modal renders as a plain block element
     in document flow ("unten links gequetscht", reported 2026-05-01). Vars
     like --shadow-lg / --bg-card-2 may not exist in every host CSS, so each
     uses a literal fallback. */
  .player-overlay { position: fixed; inset: 0; z-index: 200;
                     display: flex; align-items: center; justify-content: center;
                     animation: zap-overlay-in .18s ease; }
  .player-overlay__backdrop { position: absolute; inset: 0;
                                background: rgba(13,15,18,.75);
                                backdrop-filter: blur(4px); }
  /* Embedded mode: the native video composites BEHIND the transparent WebView.
     The backdrop's backdrop-filter:blur builds an opaque GPU layer from the app
     behind it and occludes the transparent stage even with a transparent
     background (background:transparent does NOT disable backdrop-filter, and a
     runtime strip does not reflect — Chromium caches the layer). Kill it
     statically so it never composites. The opaque app content behind the stage
     is hidden separately at attach time (visibility, which does reflect). */
  html.zap-embedded-player .player-overlay__backdrop { display: none !important; }
  /* backdrop-filter promotes a Chromium compositing layer that can force the
     WHOLE WebEngineView surface opaque — then the transparent stage no longer
     reveals the native video below (the "frames flow + item visible but stage
     black" case; proven the engine/compositing/capture all work via --quick-gpu,
     so the page is the only variable). Kill every backdrop-filter in embedded so
     the view stays truly transparent. (Header/controls just lose their blur.) */
  html.zap-embedded-player .player-overlay *,
  html.zap-embedded-player .po-controls,
  html.zap-embedded-player .po-controls * {
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
  }
  /* The warmup/buffering overlay is a 55%-opaque dark sheet over the whole stage;
     in embedded it dims/occludes the native video behind the stage on every
     (re)buffer + seek (the "flickering loading ring over no picture"). The native
     engine handles its own buffering — keep the spinner visible but drop the dark
     backing so the video shows through. */
  html.zap-embedded-player .zap-warmup-overlay { background: transparent !important; }
  /* THE embedded video-display fix (verified): the native shell composites engine
     video BELOW this WebEngineView. A perpetual CSS animation/transition makes
     Chromium repaint the WebView continuously, and the regenerated WebView texture
     is momentarily opaque when the Qt scene-graph re-samples it at the video frame
     rate → the native video flickers + blacks out ("spielt ab, kein Bild, flackert
     brutal"). With animations frozen the WebView texture stays stable + transparent
     and the video composites through cleanly. Embedded only; the native client's
     chrome just loses decorative motion. */
  html.zap-embedded-player *,
  html.zap-embedded-player *::before,
  html.zap-embedded-player *::after {
    animation: none !important;
    transition: none !important;
  }
  .player-overlay__panel { position: relative;
                            background: var(--bg-card, #fff);
                            border-radius: var(--r-lg, 14px);
                            box-shadow: var(--shadow-lg, 0 24px 64px rgba(0,0,0,.32), 0 8px 24px rgba(0,0,0,.18));
                            width: min(95vw, 1100px); max-height: 92vh;
                            display: flex; flex-direction: column; overflow: hidden; }
  .player-overlay__h { display: flex; align-items: center; gap: 10px;
                        padding: 12px 16px;
                        border-bottom: 1px solid var(--rule, #e4e6ea);
                        background: var(--bg-card-2, #fafbfc); }
  .player-overlay__title { flex: 1; font-size: 13px; font-weight: 500;
                            white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .player-overlay__hls-badge { font-family: monospace; font-size: 10px;
                                 color: var(--ink-faint, #aab0b9);
                                 text-transform: uppercase; letter-spacing: .12em;
                                 margin-left: 8px; }
  .player-overlay__toolbar { margin-left: auto; display: flex; align-items: center; gap: 4px; }
  .po-btn { width: 32px; height: 32px;
             border: 1px solid rgba(13,15,18,.14);
             background: rgba(13,15,18,.04);
             color: var(--ink, #0d0f12);
             border-radius: 6px; font-size: 16px; line-height: 1;
             display: flex; align-items: center; justify-content: center;
             cursor: pointer;
             transition: background .12s, border-color .12s, color .12s;
             user-select: none; }
  .po-btn:hover { background: rgba(13,15,18,.1); }
  .po-btn.is-on { background: var(--accent, #1d4ed8); border-color: var(--accent, #1d4ed8); color: #fff; }
  .po-btn--gear { font-size: 18px; }
  .player-overlay__close { background: transparent;
                            border: 1px solid var(--rule, #e4e6ea);
                            color: var(--ink-mid, #4a4f57);
                            border-radius: var(--r-sm, 6px);
                            padding: 5px; display: inline-flex; cursor: pointer;
                            transition: all .12s; }
  .player-overlay__close:hover { border-color: var(--danger, #dc2626);
                                   color: var(--danger, #dc2626); }
  .player-overlay__stage { position: relative; background: #050505;
                            aspect-ratio: var(--video-ratio, 16 / 9); }
  .player-overlay__stage > video { display: block; width: 100%; height: 100%;
                                     object-fit: contain; background: transparent; }
  .player-overlay__video { width: 100%; max-height: 70vh; background: black; display: block; }
  .player-overlay__settings { position: absolute; top: 12px; right: 12px;
                                width: 280px;
                                background: rgba(20,22,28,.95);
                                backdrop-filter: blur(12px);
                                border: 1px solid rgba(255,255,255,.14);
                                border-radius: 8px; padding: 14px;
                                display: flex; flex-direction: column; gap: 12px;
                                font-size: 13px; color: #fff; z-index: 6;
                                box-shadow: 0 12px 32px rgba(0,0,0,.55); }
  /* HTML5 [hidden] is display:none in the UA stylesheet, but explicit
     class-level "display:" rules win on specificity. The banner, popover,
     stats, settings panel etc. all use el.hidden = true/false — without
     these explicit overrides those elements would render open by default. */
  .player-overlay__settings[hidden],
  .zap-pe-banner[hidden],
  .zap-pe-popover[hidden],
  .zap-pe-resume[hidden] { display: none !important; }
  .player-overlay__settings label { display: flex; flex-direction: column; gap: 4px;
                                      color: rgba(255,255,255,.85); font-size: 12px; }
  .player-overlay__settings select { padding: 6px 8px;
                                       background: rgba(255,255,255,.08); color: #fff;
                                       border: 1px solid rgba(255,255,255,.18);
                                       border-radius: 4px; font-size: 13px;
                                       font-family: inherit; cursor: pointer; }
  .player-overlay__settings select option { background: #1a1f28; color: #fff; }
  .player-overlay__settings .po-checkbox { flex-direction: row; align-items: center; gap: 8px;
                                              cursor: pointer; color: rgba(255,255,255,.9); }
  .player-overlay__settings .po-checkbox input { margin: 0; cursor: pointer; }
  .player-overlay__settings .po-checkbox .dim { color: rgba(255,255,255,.5); font-size: 11px; }
  .player-overlay__f { padding: 12px 16px;
                        border-top: 1px solid var(--rule, #e4e6ea);
                        display: flex; flex-direction: column; gap: 6px;
                        font-size: 11px; }
  .player-overlay__f kbd { display: inline-block; padding: 0 4px;
                             background: rgba(0,0,0,.06);
                             border: 1px solid var(--rule-soft, #eef0f3);
                             border-radius: 3px;
                             font-family: monospace; font-size: 10px; }
  .player-overlay__url { width: 100%; padding: 6px 10px;
                          border: 1px solid var(--rule, #e4e6ea);
                          border-radius: var(--r-sm, 6px);
                          background: var(--bg-app, #f6f7f9);
                          font-size: 11px;
                          font-family: monospace; }
  .player-overlay__url:focus { outline: none; border-color: var(--accent, #1d4ed8); }
  @keyframes zap-overlay-in { from { opacity: 0; } to { opacity: 1; } }

  /* === Help-Overlay (?-Key) — sits above modal (z-index > .player-overlay's 200) */
  .zap-help-overlay { position: fixed; inset: 0; z-index: 250;
                       display: flex; align-items: center; justify-content: center;
                       padding: 20px; }
  .zap-help-overlay__backdrop { position: absolute; inset: 0;
                                  background: rgba(0,0,0,.55);
                                  backdrop-filter: blur(3px); }
  .zap-help-overlay__panel { position: relative; z-index: 1;
                              max-width: 920px; width: 100%; max-height: 86vh;
                              background: rgba(20,22,28,.97);
                              border: 1px solid rgba(255,255,255,.18);
                              border-radius: 10px;
                              box-shadow: 0 18px 56px rgba(0,0,0,.7);
                              color: #fff; display: flex; flex-direction: column;
                              overflow: hidden; }
  .zap-help-overlay__h { display: flex; align-items: center; justify-content: space-between;
                          padding: 14px 18px;
                          border-bottom: 1px solid rgba(255,255,255,.1);
                          background: rgba(255,255,255,.03); }
  .zap-help-overlay__h h3 { margin: 0; font-size: 16px; font-weight: 600;
                             font-family: system-ui, sans-serif; }
  .zap-help-overlay__close { background: transparent; border: 0;
                              color: rgba(255,255,255,.7); font-size: 22px;
                              line-height: 1; padding: 0 6px; cursor: pointer; }
  .zap-help-overlay__close:hover { color: #fff; }
  .zap-help-overlay__f { padding: 10px 18px;
                          border-top: 1px solid rgba(255,255,255,.08);
                          background: rgba(255,255,255,.03);
                          font-size: 11px; }
  .zap-help-explainer { padding: 14px 18px 18px; line-height: 1.5;
                         border-top: 1px solid rgba(255,255,255,.08);
                         color: rgba(255,255,255,.85); font-size: 12.5px;
                         max-height: 40vh; overflow: auto; }
  .zap-help-explainer h4 { margin: 0 0 8px; font-size: 14px; font-weight: 600;
                            color: #fff; font-family: system-ui, sans-serif; }
  .zap-help-explainer p { margin: 0 0 9px; }
  .zap-help-explainer p strong { color: #fff; }
  .zap-help-explainer kbd { display: inline-block; padding: 1px 5px;
                             background: rgba(255,255,255,.12);
                             border: 1px solid rgba(255,255,255,.22);
                             border-radius: 3px; font-family: monospace;
                             font-size: 11px; color: #fff; }
  .zap-help-overlay__f .dim { color: rgba(255,255,255,.5); }
  .zap-help-overlay__f .mono { font-family: monospace; }
  .zap-help-grid { display: grid; grid-template-columns: repeat(3, 1fr);
                    gap: 18px; padding: 18px;
                    overflow: auto; flex: 1 1 auto; }
  @media (max-width: 760px) { .zap-help-grid { grid-template-columns: 1fr; } }
  .zap-help-col { display: flex; flex-direction: column; gap: 6px; }
  .zap-help-col__h { font-size: 11px; letter-spacing: .12em;
                      text-transform: uppercase; color: #1ED760;
                      font-family: monospace; padding-bottom: 6px;
                      border-bottom: 1px solid rgba(30,215,96,.3); margin-bottom: 4px; }
  .zap-help-row { display: grid; grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
                   gap: 10px; align-items: baseline;
                   font-size: 12.5px; line-height: 1.5; padding: 2px 0; }
  .zap-help-row > span:first-child { color: rgba(255,255,255,.95); white-space: normal; }
  .zap-help-row > span:last-child  { color: rgba(255,255,255,.7); }
  .zap-help-row kbd { display: inline-block; padding: 1px 6px;
                       background: rgba(255,255,255,.12);
                       border: 1px solid rgba(255,255,255,.22);
                       border-radius: 3px;
                       font-family: monospace; font-size: 11px;
                       color: #fff; }
  .zap-help-mouse { display: inline-block; padding: 1px 6px;
                     background: rgba(30,215,96,.18);
                     border: 1px solid rgba(30,215,96,.38);
                     border-radius: 3px;
                     font-family: monospace; font-size: 11px;
                     color: #a8c2f0; }

  /* === Inline-Toolbar (when ZapPlayer mounts on an existing <video>) === */
  /* Modal mode has its own .player-overlay__toolbar in zap.css — these rules
     only apply when the player is hosted inline (e.g. a non-modal embed). */
  .zap-toolbar-inline { position: absolute; top: 8px; right: 8px; z-index: 5;
                         display: flex; gap: 4px;
                         background: rgba(20,22,28,.7);
                         backdrop-filter: blur(4px);
                         border: 1px solid rgba(255,255,255,.12);
                         border-radius: 6px; padding: 3px;
                         opacity: 0; transition: opacity .15s; pointer-events: none; }
  .zap-toolbar-inline:hover,
  *:hover > .zap-toolbar-inline,
  .zap-toolbar-inline:focus-within {
    opacity: 1; pointer-events: auto;
  }
  .zap-toolbar-inline .po-btn { background: transparent; border: 0;
                                 color: rgba(255,255,255,.85);
                                 cursor: pointer; padding: 4px 8px;
                                 border-radius: 4px; font-size: 14px;
                                 line-height: 1; }
  .zap-toolbar-inline .po-btn:hover { background: rgba(255,255,255,.14);
                                       color: #fff; }
  .zap-toolbar-inline .po-btn.is-on { background: rgba(30,215,96,.25);
                                       color: #1ED760; }

  /* === B6: Timeline scrub-thumbnail (storyboard) preview === */
  /* Sits above the existing time-tooltip (bottom:100% of the scrubber +
     margin to clear the tooltip). W×H come from index.json (set inline).
     z-index 6 keeps it above the tooltip (5) and the controls bar (5).
     background-* (image/position/size) are set inline per hover frame. */
  .po-controls__scrubber__thumbpreview {
    position: absolute; bottom: 100%; margin-bottom: 14px;
    transform: translateX(-50%);
    border-radius: 6px; border: 1px solid rgba(255,255,255,.22);
    box-shadow: 0 6px 20px rgba(0,0,0,.6);
    background-color: #000; background-repeat: no-repeat;
    pointer-events: none; overflow: hidden; z-index: 6; }
  .po-controls__scrubber__thumbpreview[hidden] { display: none; }

  /* === Subtitle cue overlay (Sidecar-WebVTT, Browser + Shell) === */
  /* z-index 4 sits above the canvas (0) but BELOW the controls bar (.po-controls,
     z-index 5) so cue text never paints over the scrubber/buttons; bottom 12%
     keeps cues clear of the control bar's height during normal playback. */
  .zap-cue-overlay { position: absolute; left: 0; right: 0; bottom: 12%;
                     display: flex; flex-direction: column; align-items: center;
                     gap: 4px; padding: 0 5%; text-align: center;
                     pointer-events: none; z-index: 4; }
  .zap-cue { display: inline-block; max-width: 92%; white-space: pre-wrap;
             background: rgba(0,0,0,.72); color: #fff; border-radius: 4px;
             padding: 2px 10px; font-weight: 500; line-height: 1.3;
             font-size: clamp(16px, 2.4vw, 30px);
             text-shadow: 0 1px 2px rgba(0,0,0,.9); }
`;

export function injectCss() {
  if (document.getElementById('zap-pe-css')) return;
  const el = document.createElement('style');
  el.id = 'zap-pe-css';
  el.textContent = CSS;
  document.head.appendChild(el);
}
